/* eslint-disable import/prefer-default-export */
import Fetch, { V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: {
    sre_001: '',
    sre_008: '',
  },
};

const getCategoryNotif = () => {
  const resourceUrl = `${V1}notification/user/history-category/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message);
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export { getCategoryNotif };
